import React from "react";

import { SVGSprite } from "@/components/Atoms";

import { clsx } from "@/utils";

interface SlickArrowButtonProps {
  buttonType: "prev" | "next";
  currentSlide?: number;
  slideCount?: number;
  className?: string;
  icon?: any;
  iconProps?: any;
  children?: React.ReactNode;
}

const SlickArrowButton: React.FC<SlickArrowButtonProps> = ({
  buttonType,
  currentSlide,
  slideCount = 1,
  className,
  icon,
  iconProps,
  ...props
}) => {
  let disabled = false;
  if (buttonType === "prev") {
    disabled = currentSlide === 0;
  } else {
    disabled = currentSlide === slideCount - 1;
  }

  return (
    <button
      className={clsx(className, disabled ? " slick-disabled" : "")}
      aria-hidden="true"
      aria-disabled={disabled ? true : false}
      {...props}
    >
      {typeof icon === "string" ? (
        <SVGSprite icon={icon} {...iconProps} />
      ) : (
        icon
      )}
    </button>
  );
};

export default SlickArrowButton;
